import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Box, Text, VStack } from '@chakra-ui/react';

const ComboIndicator = ({ combo }) => {
  if (combo < 2) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.5, opacity: 0 }}
      >
        <Box
          position="fixed"
          top="50%"
          right="20px"
          transform="translateY(-50%)"
          bg="purple.500"
          color="white"
          p={4}
          borderRadius="lg"
          boxShadow="xl"
        >
          <VStack spacing={0}>
            <Text fontSize="3xl" fontWeight="bold">{combo}x</Text>
            <Text fontSize="sm">COMBO!</Text>
          </VStack>
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default ComboIndicator; 